export const categoriesListKey = () => ["categories-list"];

export const categoriesListParamsKey = ({ queryParams }) => [...categoriesListKey(), queryParams];
